export class ResetPasswordModel {
  username = '';
  password = '';
  token = '';
}
